import {postApi} from '../api';

export const changepasswordApi =  (data) => postApi(`/auth/setPassword`, data);